/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Media_Pick_CountInputs */

const vi_media_pick_count = /** @type {(inputs: Media_Pick_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chọn (${i?.count})`)
};

/**

* @param {Media_Pick_CountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_pick_count = /** @type {((inputs: Media_Pick_CountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Pick_CountInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_pick_count(inputs)
});